export function getLinks() {
  return [];
}

export function isCurrentPage(link) {
  return link.path && window.location.pathname.includes(link.path) || false;
}
